/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SwatchSelector_item$ref = any;
export type PdpRespSwatchSelector_item$ref = any;
export type PdpRespSwatchSelector_item = {
    readonly " $fragmentRefs": SwatchSelector_item$ref;
    readonly " $refType": PdpRespSwatchSelector_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSwatchSelector_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SwatchSelector_item",
            "args": [
                {
                    "kind": "Literal",
                    "name": "shouldFetchBuyerInfo",
                    "value": true
                }
            ]
        }
    ]
} as any);
(node as any).hash = '376b451a90f2ab28f5b94e7af2f4f6bd';
export default node;
